import { LanguagesPack } from '@/store/types';

export enum StoreActions {
  CONTENT = 'FETCH_CONTENT',
  TREE = 'FETCH_TREE',
  SEARCH = 'FETCH_SEARCH',
  COUNTRY_CODE = 'FETCH_REGION',
}

export enum StoreMutations {
  CONTENT = 'SET_CONTENT',
  COUNTRY_CODE = 'SET_REGION',
  TREE = 'SET_TREE',
  SEARCH = 'SET_SEARCH',
  SET_CURRENT_LANG = 'SET_SELECTED_LANGUAGES',
  SET_CURRENT_LOCALE = 'SET_SELECTED_LOCALES',
  SET_LANGUAGES = 'SET_LANGUAGE_STORE_PACK',
  ROOT_NAMES = 'SET_ROOT_NAMES',
  SET_RENDER_PAGE_STATUS = 'SET_RENDER_PAGE_STATUS',
  BREADCRUMBS = 'SET_BREADCRUMBS',
  SET_FILTERED_VALUE = 'SET_FILTERED_VALUE',
  SET_CONTENT_LOADING = 'SET_CONTENT_LOADING',
  SET_MOBILE_CODE_RAILS = 'SET_MOBILE_CODE_RAILS',
  SET_STATUS_OF_PAGEINCLUDESCODEEXAMPLES = 'SET_STATUS_OF_PAGEINCLUDESCODEEXAMPLES',
  UPDATE_LANGUAGES_PACK = 'UPDATE_LANGUAGES_PACK',
  SET_LISTENERS_STATE = 'SET_LISTENERS_STATE',
  SET_CURRENT_ANCHOR = 'SET_CURRENT_ANCHOR',
  SET_PROGRESSBAR_STATUS = 'SET_PROGRESSBAR_STATUS',
  SET_MOBILE_STATE = 'SET_MOBILE_STATE',
}

export enum GlobalBusNames {
  TOGGLEMOBILE = 'toggle_mobile',
  RENDERSEARCH = 'render_search',
  ISMOBILE = 'is_mobile_responsive',
  SEARCHRESULT = 'search_result_render',
  CHANGEEXAMPLE = 'change_example',
  TAKERATING = 'take_rating',
  CLOSEMOBILEMENU = 'close_mobile_menu',
  COPIEDTOCLIPBOARD = 'copied_to_clipboard',
  CHANGESDK = 'change_sdk',
  NEWLANGUAGEPACKLOADED = 'new_language_pack_loaded',
  CHANGELANGUAGE = 'change_lang_on_lang_selector',
  CHANGELOCALE = 'change_locale_on_locale_selector',
  CHECKENABLEDLANGS = 'check_enabled_langs',
  LEGENDOPTIONSSCROLL = 'scroll_from_legend_options',
}

export interface SearchItem {
  fqdn: string;
  description: string | { [key in keyof LanguagesPack]: string };
  title: string | { [key in keyof LanguagesPack]: string };
  root_fqdn: string;
  kind: string;
}

export interface LocaleItem {
  title: string;
  icon: string;
  lc: string;
}

export interface ResultsDataSearch {
  inputString: string;
  searchResults: any;
}
